import { Dialog } from '@angular/cdk/dialog';
import { Component, Inject, inject, Input, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { values } from 'lodash';
import { CommonDialogData } from 'src/app/models/CommonDialogData';
import { ApiService } from 'src/app/services/api.service';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from './../../../models/Constants';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { LogoutBusinessLogicService } from 'src/app/services/logout-business-logic.service';
import { BatchAlertService } from 'src/app/services/batch-alert.service';
@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnInit {
  iconConfig: any;

  timeoutMsg = Constants.Timeout_Msg;

  @Input()
  msg!: string;

  constructor(
    public rootScope: RootScopeService,
    public apiService: ApiService,
    public genesysCloudService: GenesysCloudService,
    public router: Router, public logOutService: LogoutBusinessLogicService,
    public batchAlertService: BatchAlertService,
    @Inject(MAT_DIALOG_DATA) public data: CommonDialogData
  ) {
    this.iconConfig = {
      iconName: 'times',
      iconType: 'fal',
    };
  }

  ngOnInit(): void { }



  modelClosed() {
    this.apiService.handleMultiSession(false);
  }

  // Common method for Button Click
  commonButton(type) {
    switch (type) {
      case Constants.buttonEnum.restoreLastSession:
        {
          this.modelClosed();
          
          if (this.batchAlertService.checkBatchAlertModeActive()) {
            this.batchAlertService.turnBatchAlertModeOnWithoutRoute();
          }
        }
        break;
      case Constants.buttonEnum.opneNewSession:
        this.apiService.handleMultiSession(true);
        sessionStorage.removeItem('isBatchAlertModeActive');
        break;
      case 'I’ll call later':
        {
          // console.log("hello i am : I’ll call late ")
        }

        break;
      case 'Got it':
        this.rootScope.isModelopen = false;
        if (this.data.comingFrom == Constants.comptFrom.Max_Account) {
          // let tabs = this.rootScope.customerTabs;
          if (this.rootScope.checkCallOrChat()) {
            /* istanbul ignore next */
            setTimeout(() => {
              if (this.rootScope.holdLiveDetails[0]?.id)
                this.genesysCloudService.customerService.showPopup();
            }, 15000);
          } else {
            this.rootScope.customerLink =
              this.rootScope.activeCustTab?.customerSessionId ? this.rootScope.activeCustTab.customerSessionId : 0; //?tabs[tabs.length - 1].id;

            /*check if customerLink exist in the opened customer tab's . 
            If not exist then update the this.rootScope.customerLink to zero . So that it redirect to Customer Search Tab , 
            rather then any invalid route */

            let existingTab = this.rootScope.getObjFromArray(
              this.rootScope.customerTabs,
              'customerSessionId',
              this.rootScope.customerLink
            );

            if (existingTab == undefined) {
              this.rootScope.customerLink = 0;
            }


            // this.rootScope.activeCustTab = this.rootScope.getObjFromArray(
            //   this.rootScope.customerTabs,
            //   'customerSessionId',
            //   this.rootScope.customerLink
            // );

            this.genesysCloudService.customerService.updateActiveTabDetails(this.rootScope.customerLink);

            //console.log('rootScope.customerLink ++++' + this.rootScope.customerLink);
            // Added condition to implemenent CCR1-3203 issue no 2
            /* istanbul ignore next */
            if (this.rootScope.customerLink != 0) {
              // console.log('Condition satisfied ' + this.rootScope.customerLink);

              this.rootScope.router.navigate(
                [`/customer-account/${this.rootScope.customerLink}`],
                {
                  skipLocationChange: true,
                }
              );
            }

          }
        } else if (this.data.comingFrom == 'userprofile') {
          this.rootScope.customerLink =
            this.rootScope.activeCustTab.customerSessionId; //?tabs[tabs.length - 1].id;
          this.genesysCloudService.customerService.updateActiveTabDetails(
            this.rootScope.customerLink
          );
          // this.rootScope.activeCustTab = this.rootScope.getObjFromArray(
          //   this.rootScope.customerTabs,
          //   'id',
          //   this.rootScope.customerLink
          // );

          if (this.rootScope.activeLink == Constants.CCR_Dashboard)
            this.rootScope.activeLink = Constants.CUSTOMER_SEARCH;
          if (this.rootScope.activeLink == Constants.CCR_Dashboard) {
            this.rootScope.router.navigate([`/customer-search`], {
              skipLocationChange: true,
            });
          }
          /* istanbul ignore next */
          if (this.rootScope?.activeCustTab?.id == 1) {
            this.rootScope.router.navigate([`/customer-search-unidentified-call/${this.rootScope.customerLink}`], {
              skipLocationChange: true,
            });
          } else {
            this.rootScope.router.navigate(
              [`/customer-account/${this.rootScope.customerLink}`],
              {
                skipLocationChange: true,
              }
            );
          }
        }
        // else if (this.data.comingFrom == 'main') {
        //   /**** Here new opened tab will be redirected to google default home page ***/
        //   window.open('http://www.google.com', '_self');
        // }

        break;
      case Constants.buttonEnum.stillWorking://timeout button 
        this.rootScope.clearInterval = true;
        break;
      case Constants.buttonEnum.logOut://timeout button 
        this.rootScope.clearInterval = true;
        this.logOutService.validateLogOut(this);
        break

      case Constants.buttonEnum.continue:
        if(this.rootScope.invalidENV){
          this.rootScope.invalidENVBanner= true;
          this.rootScope.invalidENV = false;
          console.log("Invalid Environment");
        }
        else
        this.rootScope.turnSimulationModeOn(); 
        
      break;

      case Constants.CANCEL_BUTTON_TYPE:
       // this.rootScope.simulationData.isSimulationToggleOn = false;
       /* istanbul ignore next */
        setTimeout(() => {
          this.rootScope.simulationData.isSimulationToggleOn = false;
         // sessionStorage.setItem('isSimulationMode', 'true');
          this.rootScope.simulationData.isSimulationModeActive = false;
          }, 500);
        
      break;
       //CCR3-10534
      case Constants.buttonEnum.doNotRegister:
        this.genesysCloudService.logOutUser(true).subscribe((res) => {
          if (res)
            console.log(res);
        });
        this.apiService.genesysLogout(this.rootScope.invalidENV);
        break;
      default:
        break;
    }
  }

  ngOnDestroy() {
    this.rootScope.scrollToTop();
  }
}
